
function IntervalField() {
	return {
		require: ['ngModel', '^^?fieldBox'],
		restrict: 'A',
		scope: true,
		link: function($scope, element, attrs, controllers) {
			var ngModel = controllers[0];
			var fieldBox = controllers[1];
			$scope.i = {years:0, mons:0, days:0, hours:0, mins:0, secs:0};
			var hide = $scope.$eval(attrs.hide) || {}

			ngModel.$formatters.push(function(value){
				var i = {years:0, mons:0, days:0, hours:0, mins:0, secs:0, sign:"+"};
				if (!value) value = "00:00:00";
				var split = value.split(/ *(year|mon|day)s? */)
				while(split.length) {
					var val = split.shift();
					if (split.length) {
						var unit = split.shift() + 's';
						i[unit] = parseInt(val);
						if (i[unit] < 0 && fieldBox && fieldBox.field.client && fieldBox.field.client.sign_fields) {
							i.sign = "-";
							i[unit] = - i[unit]
						}
					} else if (val.indexOf(":")) {
						i.time = val
					}
				}
				if (hide.years) i.mons += 12 * i.years;
				if (hide.mons) i.days += 30 * i.mons;  // fuzzy
				return i;
			});
			
			ngModel.$parsers.push(function(i){
				if (!i) return;
				var interval = '';
				var sign = i.sign == '+' ? '' : '-'
				if (i.years && !hide.years) interval += sign + i.years + ' years '
				if (i.mons && !hide.mons) interval += sign + i.mons + ' mons '
				if (i.days && !hide.days) interval += sign + i.days + ' days '
				if (i.time && !hide.time) {
					interval += sign + i.time;
				}
				interval = interval.replace(/ $/, '')
				return interval;
			});

			$scope.$watchCollection('i', function(value) {
				if (!value) return;
				value = angular.copy(value)
				ngModel.$setViewValue(value);
			}, true);
			
			ngModel.$render = function() {
				$scope.i = ngModel.$viewValue;
				//$scope.pass.repeat = ngModel.$modelValue;
			};
		},
	}
}

function IntervalFieldController($scope) {
		$scope.i = {};
		// eg "1 year 5 mons 31 days 24:00:00"
		$scope.$watch('object[field.name]', function(value) {
			$scope.i.years = 0;
			$scope.i.mons = 0;
			$scope.i.days = 0;
			$scope.i.hours = 0;
			$scope.i.mins = 0;
			$scope.i.secs = 0;
			if (!value) value = "00:00:00";
			var split = value.split(/ *(year|mon|day)s? */)
			while(split.length) {
				var val = split.shift();
				if (split.length) {
					var unit = split.shift() + 's';
					$scope.i[unit] = parseInt(val);
				} else {
					var parts = val.split(':');
					$scope.i.hours = parseInt(parts[0]) || 0
					$scope.i.mins = parseInt(parts[1]) || 0
					$scope.i.secs = parseInt(parts[2]) || 0
				}
			}
			var hide = $scope.field.hide_fields || {};
			if (hide.years) $scope.i.mons += 12 * $scope.i.years;
			if (hide.mons) $scope.i.days += 30 * $scope.i.mons;  // fuzzy
		});
		$scope.$watch('i', function(i){
			var hide = $scope.field.hide_fields || {};
			if (!i) return;
			var interval = '';
			if (i.years && !hide.years) interval += i.years + ' years '
			if (i.mons && !hide.mons) interval += i.mons + ' mons '
			if (i.days && !hide.days) interval += i.days + ' days '
			if (i.hours || i.mins || i.secs) {
				if (i.secs > 59) i.secs = 59;
				if (i.secs < 0) i.secs = 0;
				if (i.mins > 59) i.mins = 59;
				if (i.mins < 0) i.mins = 0;
				if (i.hours < 0) i.hours = 0;
				var parts = _.map([i.hours, i.mins, i.secs], function(n){return n<10?('0'+n):n;});
				interval += parts.join(':');
			}
			interval = interval.replace(/ $/, '')
			$scope.object[$scope.field.name] = interval;
		}, true);
		
}



angular.module('forms.fields.interval', [])
.controller('IntervalFieldController', IntervalFieldController)
.directive('intervalField', IntervalField)
.filter('inverval_to_pl', function() {
    return function(input) {
    	if (!input) return 'brak';
		var out = input
			.replace(/^1 years?/, '1 rok')
			.replace(/([234]) years?/, '$1 lata')
			.replace(/years?/, 'lat')
			.replace(/ 1 mons?/, ' 1 miesiąc')
			.replace(/([234]) mons?/, '$1 miesiące')
			.replace(/mons?/, 'miesięcy')			
			.replace(/ 1 days?/, ' 1 dzień')
			.replace(/([234]) days?/, '$1 dni')
			.replace(/days?/, 'dni')
		return out;
  }
});